<template>
  <div>
    <div style="margin-bottom:50px ">
      <span>产品：</span>
      <v-select style="width: 220px;margin-right: 20px"
                :data="appOptions"
                placeholder="选择产品组"
                :allowClear="false"
                v-model="appValue"></v-select>
      <v-button type="primary"
                @click="search">筛选</v-button>
      <v-button type="primary"
                @click="addVisible=true">添加</v-button>
    </div>
    <el-table :data="currentTableData">
      <el-table-column label="图片">
        <template slot-scope="scope">
          <div :style="{width: '70px',height: '70px',backgroundPosition:'center',backgroundSize:'contain',backgroundImage:'url('+scope.row.img_url+')'}" :src="scope.row.img_url"></div>
        </template>
      </el-table-column>
      <el-table-column label="名称和简介">
        <template slot-scope="scope">
          <div>
            <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{scope.row.name}}</p>
            <a style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block" :href="scope.row.jump_url">{{scope.row.jump_url}}</a>
            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{scope.row.summary}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="handleDelete(scope.row)"
                     size="small">删除</el-button>
          <el-button type="text"
                     @click="goEdit(scope.row)"
                     size="small">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next"
      style="float: right"
      :total="tableData.length"
      :current-page="page"
      :page-size="5"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <v-modal :title="addVisible?'新增':'编辑'"
             :width=600
             :visible="addVisible||editVisible"
             @ok="submit"
             @cancel="closeModal">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="摘要">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>
        <el-form-item label="文章链接">
          <el-input v-model="form.jump_url"></el-input>
        </el-form-item>
        <el-form-item label="封面上传">
          <el-upload
            class="avatar-uploader"
            action="/dev/upload_img"
            :headers="header"
            name="img"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            >
            <img v-if="form.img_url" :src="form.img_url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
       </el-form>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'
// 200806145681206001j cff27be6c59c11ea9a8100163e009f55
export default {
  data () {
    return {
      appOptions: [],
      appValue: '',
      rangeDate: ['', ''],
      tableData: [],
      currentTableData: [],
      page: 1,
      limit: 5,
      addVisible: false,
      editVisible: false,
      chooseData: {},
      imageUrl: '',
      header: { 'server-mode': this.$store.state.serverMode },
      form: {
        name: '',
        summary: '',
        img_url: '',
        jump_url: ''
      }
    }
  },
  methods: {
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
      })
    },
    handleSearch () {
      this.page = 1
      this.search()
    },
    handleCurrentChange (val) {
      this.page = val
      this.currentData()
    },
    search () {
      let appValue
      appValue = this.appValue
      let url = '/dev/advertisemen_info'
      url = url + '?package_key=' + appValue + '&advertisemen_type=articles'
      axios.get(url)
        .then(res => {
          this.tableData = res.data.data
          this.currentData()
        })
    },
    currentData () {
      this.currentTableData = this.tableData.slice((this.page - 1) * this.limit, this.page * this.limit)
      console.log(this.currentTableData)
    },
    handleDelete (data) {
      this.chooseData = data
      let that = this
      this.$modal.confirm({
        maskClosable: true,
        title: '提示',
        content: '您是否确认要删除这项内容',
        onOk: function () {
          that.deleteFn()
        },
        onCancel: function () {}
      })
    },
    deleteFn () {
      let data = {...this.chooseData, jump_url: `DEL@`}
      // eslint-disable-next-line camelcase
      let current_index = 0
      this.tableData.forEach((item, index) => {
        if (item.img_url === data.img_url) {
          // eslint-disable-next-line camelcase,no-const-assign
          current_index = index
        }
      })
      let list = [...this.tableData]
      list.splice(current_index, 1, data)
      axios.post(`/dev/advertisemen_info`, { package_key: this.appValue, advertisemen_type: 'articles', data: { data: list, state: true } })
        .then(res => {
          this.search()
        })
    },
    goEdit (data) {
      this.form = data
      this.editVisible = true
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 200) {
        this.form.img_url = res.show_url
      }
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = {...this.form}
          let list = [...this.tableData]
          if (this.addVisible) {
            data = {...data, jump_url: `${data.jump_url}`}
            let dataList = [data]
            list = dataList.concat(list)
          } else if (this.editVisible) {
            // eslint-disable-next-line camelcase
            let current_index = 0
            this.tableData.forEach((item, index) => {
              if (item.img_url === data.img_url) {
                // eslint-disable-next-line camelcase,no-const-assign
                current_index = index
              }
            })
            list.splice(current_index, 1, data)
          }
          axios.post(`/dev/advertisemen_info`, { package_key: this.appValue, advertisemen_type: 'articles', data: { data: list, state: true } })
            .then(res => {
              this.closeModal()
              this.search()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeModal () {
      this.addVisible = false
      this.editVisible = false
      this.form = {
        name: '',
        summary: '',
        img_url: '',
        jump_url: ''
      }
    }
  },
  created () {
    this.getApps()
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload .el-upload__input {
    width: 0;
    height: 0;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/consult/consult.vue